export default __webpack_public_path__ + "static/media/haier.83f3f670.png";